import { HollowTitle } from './Blocks';
import { Link } from 'react-router-dom';

// Dark banner at the top of every inner page: breadcrumb, title and description.
export default function PageHero({ eyebrow, title, description, crumbs = [], children }) {
  return (
    <section className="relative overflow-hidden bg-ink pb-16 pt-36 text-white sm:pb-24 sm:pt-44">
      <div className="grid-bg pointer-events-none absolute inset-0" />
      <div className="pointer-events-none absolute -left-32 top-10 h-[420px] w-[420px] rounded-full bg-brand/40 blur-[120px]" data-parallax="0.4" />
      <div className="pointer-events-none absolute -right-32 bottom-0 h-[360px] w-[360px] rounded-full bg-brand-lime/20 blur-[120px]" data-parallax="-0.3" />
      <div className="container-x relative">
        <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-2 text-sm text-white/55" data-anim="down">
          <Link to="/" className="hover:text-brand-lime">Home</Link>
          {crumbs.map((c) => (
            <span key={c.label} className="flex items-center gap-2">
              <span aria-hidden="true">/</span>
              {c.to ? <Link to={c.to} className="hover:text-brand-lime">{c.label}</Link> : <span className="text-brand-lime">{c.label}</span>}
            </span>
          ))}
        </nav>
        {eyebrow && <span className="eyebrow eyebrow-dark mt-6" data-anim="down">{eyebrow}</span>}
        <h1 className="mt-5 max-w-4xl text-4xl font-bold leading-[1.1] sm:text-5xl lg:text-6xl" data-split data-delay="0.1"><HollowTitle dark>{title}</HollowTitle></h1>
        {description && <p className="mt-6 max-w-2xl text-lg leading-relaxed text-white/70" data-anim="up" data-delay="0.3">{description}</p>}
        {children && <div className="mt-8" data-anim="up" data-delay="0.45">{children}</div>}
      </div>
    </section>
  );
}
